import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, createSlots as _createSlots, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h3", null, "Add from text", -1)
const _hoisted_2 = { class: "max-h-[calc(100vh-300px)] overflow-auto" }
const _hoisted_3 = { class: "mt-2 sm:mt-4" }
const _hoisted_4 = { class: "space-y-2 sm:space-y-4" }
const _hoisted_5 = { class: "flex items-center justify-between gap-2 sm:gap-4" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "text-white font-bold text-ellipsis whitespace-nowrap overflow-hidden" }, " Bulk Create Doujin From Links ", -1)
const _hoisted_7 = { class: "flex items-center justify-between gap-2 sm:gap-4" }

import { Button, Input, Modal, Textarea } from 'ant-design-vue';
import { HttpStatusCode } from 'axios';
import { computed, ref } from 'vue';
import { useStore } from 'vuex';
import {
	CopyFilled,
	DeleteFilled,
	FileAddOutlined,
	LoadingOutlined,
	PlusOutlined
} from '@ant-design/icons-vue';
import BulkDownloadProgress from '@/components/disposable/BulkDownloadProgress.vue';
import { createDoujin } from '@/repository/doujin';
import { scrapingDoujin } from '@/util/scraping';


export default /*#__PURE__*/_defineComponent({
  __name: 'BulkCreateDoujinView',
  setup(__props) {

const store = useStore();
const statuses = ref<('Success' | 'Warning' | 'Error' | undefined)[]>([undefined]);
const urls = ref<string[]>(['']);
const isDownloading = ref(false);
const count = ref(1);
const isOpenModal = ref(false);
const isDone = ref(false);

function reset() {
	if (statuses.value.length !== urls.value.length || !isDone.value) {
		urls.value = [''];
		count.value = 1;
		statuses.value = [undefined];
	} else {
		urls.value = urls.value.filter((_, index) => statuses.value[index] === 'Error');
		count.value = urls.value.length || 1;
		statuses.value = statuses.value.filter((status) => status === 'Error');
	}

	isDownloading.value = false;
	isOpenModal.value = false;
	isDone.value = false;
}

function addItem() {
	urls.value.push('');
	count.value++;
}

function removeItem(index: number) {
	if (count.value > 1) {
		urls.value = urls.value.filter((_, i) => i !== index);
		count.value--;
	}
}

async function pasteItem(index: number) {
	urls.value[index] = await navigator.clipboard.readText();
}

const text = ref('');
async function addFromText(mode: 'ADD' | 'REPLACE') {
	const texts = text.value
		.split('\n')
		.filter((value) => value.trim().length > 0)
		.map((value) => value.trim());
	if (mode === 'REPLACE') {
		urls.value = [...texts];
		count.value = texts.length || 1;
	} else {
		urls.value.push(...texts);
		count.value += texts.length;
	}
	text.value = '';
	isOpenModal.value = false;
}

async function bulkDownload() {
	if (urls.value.length === 0) {
		return;
	}
	isDownloading.value = true;
	isDone.value = false;
	statuses.value = urls.value.map(() => undefined);
	try {
		for (let i = 0; i < urls.value.length; i++) {
			const url = urls.value[i];
			try {
				const doujin = await scrapingDoujin(url);
				if (doujin.imageURLs.length === 0) {
					throw Error('image not found');
				}
				const res = await createDoujin(doujin);
				statuses.value[i] =
					res.status === HttpStatusCode.Ok
						? 'Success'
						: res.status === HttpStatusCode.Conflict
							? 'Warning'
							: 'Error';
			} catch (error) {
				statuses.value[i] = 'Error';
			}
		}
		store.dispatch('alert', { type: 'success', message: `Bulk download doujin successfully!` });
	} catch (error) {
		store.dispatch('alert', {
			type: 'error',
			message: `${error}` || 'something went wrong, please try again!'
		});
	} finally {
		isDownloading.value = false;
		isDone.value = true;
	}
}

const successTotal = computed(() => statuses.value.filter((status) => status === 'Success').length);
const failedTotal = computed(
	() => statuses.value.filter((status) => status === 'Error' || status === 'Warning').length
);
const isInvalidURL = computed(() => urls.value.filter((url) => url.trim().length === 0).length > 0);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_unref(Modal), {
      open: isOpenModal.value,
      onCancel: _cache[4] || (_cache[4] = () => (isOpenModal.value = false))
    }, {
      title: _withCtx(() => [
        _hoisted_1
      ]),
      footer: _withCtx(() => [
        _createVNode(_unref(Button), {
          type: "primary",
          danger: "",
          onClick: _cache[1] || (_cache[1] = () => (isOpenModal.value = false))
        }, {
          default: _withCtx(() => [
            _createTextVNode(" Cancel ")
          ]),
          _: 1
        }),
        _createVNode(_unref(Button), {
          type: "primary",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (addFromText('REPLACE'))),
          disabled: text.value.trim().length === 0 || isDone.value
        }, {
          default: _withCtx(() => [
            _createTextVNode(" Replace ")
          ]),
          _: 1
        }, 8, ["disabled"]),
        _createVNode(_unref(Button), {
          type: "primary",
          class: "bg-green-500 hover:!bg-green-400 [&[disabled]]:!bg-gray-50",
          onClick: _cache[3] || (_cache[3] = ($event: any) => (addFromText('ADD'))),
          disabled: text.value.trim().length === 0 || isDone.value
        }, {
          default: _withCtx(() => [
            _createTextVNode(" Add ")
          ]),
          _: 1
        }, 8, ["disabled"])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_unref(Textarea), {
            placeholder: "Input urls separate by new line",
            autoSize: "",
            allowClear: "",
            value: text.value,
            onInput: _cache[0] || (_cache[0] = ($event: any) => (text.value = $event.target.value || ''))
          }, null, 8, ["value"])
        ])
      ]),
      _: 1
    }, 8, ["open"]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _hoisted_6,
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_unref(Button), {
              class: _normalizeClass(isDownloading.value ? '!bg-gray-200 border-none' : ''),
              danger: "",
              type: "primary",
              disabled: isDownloading.value,
              onClick: reset
            }, {
              default: _withCtx(() => [
                _createTextVNode(" Reset ")
              ]),
              _: 1
            }, 8, ["class", "disabled"]),
            _createVNode(_unref(Button), {
              class: _normalizeClass(
							'bg-green-500 border-none ' +
							(isDownloading.value || isDone.value || isInvalidURL.value
								? '!bg-gray-200 border-none'
								: 'hover:bg-green-400 hover:!text-black')
						),
              disabled: isDownloading.value || isDone.value || isInvalidURL.value,
              onClick: bulkDownload
            }, _createSlots({
              default: _withCtx(() => [
                _createTextVNode(" Submit ")
              ]),
              _: 2
            }, [
              (isDownloading.value)
                ? {
                    name: "icon",
                    fn: _withCtx(() => [
                      _createVNode(_unref(LoadingOutlined))
                    ]),
                    key: "0"
                  }
                : undefined
            ]), 1032, ["class", "disabled"]),
            _createVNode(_unref(Button), {
              class: _normalizeClass(
							'bg-yellow-500 border-none ' +
							(isDownloading.value || isDone.value
								? '!bg-gray-200 border-none'
								: 'hover:bg-yellow-400 hover:!text-black')
						),
              disabled: isDownloading.value || isDone.value,
              onClick: _cache[5] || (_cache[5] = () => (isOpenModal.value = true))
            }, {
              icon: _withCtx(() => [
                _createVNode(_unref(FileAddOutlined))
              ]),
              default: _withCtx(() => [
                _createTextVNode(" Add from text ")
              ]),
              _: 1
            }, 8, ["class", "disabled"]),
            _createVNode(_unref(Button), {
              onClick: addItem,
              type: "primary",
              disabled: isDownloading.value || isDone.value,
              class: _normalizeClass((isDownloading.value || isDone.value) && '!bg-gray-200 border-none')
            }, {
              icon: _withCtx(() => [
                _createVNode(_unref(PlusOutlined))
              ]),
              default: _withCtx(() => [
                _createTextVNode(" Add Link ")
              ]),
              _: 1
            }, 8, ["disabled", "class"])
          ])
        ]),
        (isDownloading.value || isDone.value)
          ? (_openBlock(), _createBlock(BulkDownloadProgress, {
              key: 0,
              total: count.value,
              success: successTotal.value,
              failed: failedTotal.value
            }, null, 8, ["total", "success", "failed"]))
          : _createCommentVNode("", true),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Array(count.value), (_, index) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "flex items-center gap-2 sm:gap-4",
            key: index
          }, [
            _createVNode(_unref(Input), {
              value: urls.value[index],
              "onUpdate:value": ($event: any) => ((urls.value[index]) = $event),
              class: _normalizeClass(
						'text-start text-full ' +
						(statuses.value[index] === 'Success'
							? '!bg-green-500 !text-white'
							: statuses.value[index] === 'Warning'
								? '!bg-yellow-500 !text-black'
								: statuses.value[index] === 'Error'
									? '!bg-red-500 !text-white'
									: '!bg-white')
					),
              placeholder: "Enter link",
              disabled: isDownloading.value || isDone.value
            }, null, 8, ["value", "onUpdate:value", "class", "disabled"]),
            _createVNode(_unref(Button), {
              onClick: ($event: any) => (pasteItem(index)),
              disabled: isDownloading.value || isDone.value,
              class: _normalizeClass((isDownloading.value || isDone.value) && '!bg-gray-200 border-none')
            }, {
              icon: _withCtx(() => [
                _createVNode(_unref(CopyFilled))
              ]),
              _: 2
            }, 1032, ["onClick", "disabled", "class"]),
            (index > 0 || (index === 0 && count.value > 1))
              ? (_openBlock(), _createBlock(_unref(Button), {
                  key: 0,
                  class: _normalizeClass(
						'bg-red-600 text-white border-none hover:bg-red-700 hover:!text-gray-300' +
						((isDownloading.value || isDone.value) && ' !bg-gray-200 border-none')
					),
                  onClick: ($event: any) => (removeItem(index)),
                  disabled: isDownloading.value || isDone.value
                }, {
                  icon: _withCtx(() => [
                    _createVNode(_unref(DeleteFilled))
                  ]),
                  _: 2
                }, 1032, ["class", "onClick", "disabled"]))
              : _createCommentVNode("", true)
          ]))
        }), 128))
      ])
    ])
  ], 64))
}
}

})